import { fontSizes, fontWeights } from '@opallabs/pulsar'
import { colors } from '@opallabs/spectrum'
import {
  sharedStyles,
  sharedColors,
} from '../../../sharedDisplays/sharedStyles'

const contentWidth = 900
const imageWidth = 600

const headerHeight = 71
const responseListHeight = 39
const addCommentHeight = 65
const postedAtHeight = 35
const dividerHeight = 1
const maxContentHeight =
  600 -
  headerHeight -
  responseListHeight -
  addCommentHeight -
  postedAtHeight -
  dividerHeight

const postInfoSection = {
  display: 'flex',
  flexFlow: 'column nowrap',
  inlineSize: contentWidth - imageWidth,
}

const header = {
  ...sharedStyles.headerLayout,
  boxSizing: 'border-box',
  flex: `0 0 ${headerHeight}px`,
  borderBlockEnd: `solid 1px ${sharedColors.responseBorderColor}`,
  paddingBlockStart: 17,
  paddingInlineEnd: 19,
  paddingBlockEnd: 17,
  paddingInlineStart: 16,
}

const avatarUsername = {
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
}

const accountNameStyles = {
  color: 'inherit',
  display: 'inline',
  fontSize: fontSizes.small,
  fontWeight: fontWeights.bolder,
}

const emptyCollabStyles = {
  color: colors.orange.base,
  display: 'inline',
  fontSize: fontSizes.small,
  fontWeight: fontWeights.bolder,
}

const accountNameWrapperStyles = {
  fontSize: fontSizes.small,
  marginLeft: 10,
  maxWidth: 200,
  overflow: 'hidden',
  paddingBlockEnd: 20,
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}

const divider = {
  backgroundColor: sharedColors.avatarBorderColor,
}

const account = (locationVisible, display) => ({
  ...sharedStyles.accountPosition(locationVisible, display),
})

const makeAssetBaseStyles = (maintainAspectRatio, imageOrientation) => ({
  backgroundColor: sharedColors.imageBackground,
  ...(Boolean(maintainAspectRatio && imageOrientation === 'landscape') && {
    maxBlockSize: 600,
    minBlockSize: 450,
  }),
  ...(Boolean(maintainAspectRatio && imageOrientation === 'portrait') && {
    maxBlockSize: 600,
  }),
})

const makeAssetStyles = (maintainAspectRatio, imageOrientation) => ({
  video: {
    inlineSize: '100%',
    height: '100%',
    objectFit: 'cover',
  },

  ...(Boolean(maintainAspectRatio && imageOrientation === 'landscape') && {
    display: 'flex', // Ensure container fits to size of asset
    maxBlockSize: 450,
    minBlockSize: 313,
    'img, video': {
      inlineSize: '100%',
      maxBlockSize: 450,
      minBlockSize: 313,
      objectFit: 'cover',
    },
  }),
  ...(Boolean(maintainAspectRatio && imageOrientation === 'portrait') && {
    display: 'flex', // Ensure container fits to size of asset
    maxInlineSize: 480,
    img: {
      maxInlineSize: 480,
    },
  }),
})

const location = {
  ...sharedStyles.locationPosition,
  color: sharedColors.igDarkGrey,
  fontSize: fontSizes.small,
  lineHeight: '21px',
  maxInlineSize: '200px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}

const responseList = {
  ...sharedStyles.responseList,
  boxSizing: 'border-box',
  flex: `0 0 ${responseListHeight}px`,
  borderBlockStart: `solid 1px ${sharedColors.responseBorderColor}`,
  paddingBlockStart: 12,
  paddingInlineEnd: 16,
  paddingBlockEnd: 0,
  paddingInlineStart: 16,
}

const responseItem = ({ bookmark = false }) => ({
  ...sharedStyles.responseItem({ bookmark }),
  '.kuiper-icon': {
    blockSize: 24,
    marginRight: bookmark ? 0 : 17,
    inlineSize: 24,
  },
})

const addCommentText = {
  ...sharedStyles.addCommentText,
  boxSizing: 'border-box',
  flex: `0 0 ${addCommentHeight}px`,
}

const contentWrapper = {
  boxSizing: 'border-box',
  maxBlockSize: maxContentHeight,
  flex: `1 0 ${maxContentHeight}px`,
  alignItems: 'stretch',
  display: 'flex',
  paddingBlockStart: 16,
  paddingInlineEnd: 16,
  paddingBlockEnd: 24,
  paddingInlineStart: 16,
  position: 'relative',
  overflowX: 'hidden',
  overflowY: 'auto',
}

const textareaContentWrapper = {
  flex: '0 0 32px',
  marginInlineEnd: 12,
}

const textareaWrapper = (isLongAccountName) => ({
  flex: '0 0 224px',
  position: 'relative',
  'span::before': {
    content: "''",
    display: isLongAccountName ? 'block' : 'initial',
  },
})

const textarea = (isLongAccountName) => ({
  fontsSize: fontSizes.large,
  inlineSize: 214,
  marginBlockStart: isLongAccountName ? '21px' : 0,
  div: {
    whiteSpace: 'unset !important',
  },
})

const accountMeasurer = {
  ...sharedStyles.accountMeasurer,
  fontSize: fontSizes.large,
}

const avatar = {
  border: `solid 1px ${sharedColors.avatarBorderColor}`,
  marginInlineEnd: 12,
}

const textareaAvater = {
  border: `solid 1px ${sharedColors.avatarBorderColor}`,
}

const postedAt = {
  ...sharedStyles.postedAt,
  paddingBlock: 12,
  paddingInline: 16,
}

const flexRow = {
  display: 'flex',
  flexDirection: 'row',
}

export const styles = {
  account,
  accountMeasurer,
  accountNameStyles,
  accountNameWrapperStyles,
  addCommentText,
  avatar,
  avatarUsername,
  contentWrapper,
  divider,
  emptyCollabStyles,
  header,
  location,
  makeAssetStyles,
  makeAssetBaseStyles,
  postedAt,
  postInfoSection,
  responseItem,
  responseList,
  textarea,
  textareaAvater,
  textareaContentWrapper,
  textareaWrapper,
  flexRow,
}
